import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ButtonComponent from "components/button/ButtonComponent";
import TableCellComponent from "components/table/TableCellComponent";
import TableRowComponent from "components/table/TableRowComponent";
import { HEADER_TIRE_LIST } from "constants/data";
import { Tire } from "../types/tire";

interface Props {
  tireList: Tire[];
  total: number;
  onPressItem?: (tire: Tire) => void;
}

/**
 * The TableTireList component.
 * @param {object} props - The component props.
 */
export default function TableTireList({ tireList, onPressItem, total }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "20px",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          textAlign: "right",
          mr: "30px",
          fontSize: { xs: 16, md: 18, lg: 20 },
          width: "100%",
          maxWidth: "1662px",
        }}
      >
        件数【{total}件】
      </Typography>
      <Box
        sx={{
          paddingBottom: "20px",
          width: "100%",
          overflowX: "auto",
        }}
      >
        <TableContainer sx={{ width: "100%", minWidth: 1140 }}>
          <Table>
            <TableHead>
              <TableRowComponent type="header" data={HEADER_TIRE_LIST} />
            </TableHead>
            <TableBody>
              {tireList.map((tire, index) => (
                <TableRow
                  sx={{ height: "75px" }}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`tire-${tire.item_cd}-${index}`}
                  className={index % 2 === 0 ? "even" : "odd"}
                >
                  <TableCellComponent label={tire.item_cd} />
                  {/* <TableCellComponent label={tire.brand_cd} /> */}
                  <TableCellComponent sx={{ textAlign: "left" }} label={tire.maker_name} />
                  <TableCellComponent sx={{ textAlign: "left" }} label={tire.brand_name} />
                  <TableCellComponent label={tire.tire_size} />
                  <TableCellComponent label={tire.tire_loin_speed_mark} />
                  <TableCellComponent>
                    <ButtonComponent
                      onClick={() => onPressItem && onPressItem(tire)}
                      sx={{
                        color: "var(--black)",
                        fontSize: { xs: 16, md: 18, lg: 20 },
                        borderRadius: "4px",
                        width: { xs: "100%", xl: "172px" },
                        height: "40px",
                      }}
                      label="詳細"
                    />
                  </TableCellComponent>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
